import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { APP_COLOR, FONT_FAMILY } from "../../theme";

export const CustomLinearProgress = (
  props: LinearProgressProps & { value: number }
): JSX.Element => {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1, color: APP_COLOR }}>
        <LinearProgress
          variant="determinate"
          {...props}
          color="inherit"
          sx={{ height: 8, borderRadius: 4 }}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontFamily: FONT_FAMILY }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
};
